import React from 'react';
import { Modal, ModalHeader, ModalBody, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { DayOfWeek } from '../constants/index';
import 'react-datepicker/dist/react-datepicker.css';

const NewBusinessHourModal = ({ isOpen, toggle, onSave, businessHours, timeframes, onInputChange }) => {
    const isFormValid = businessHours.timeframe && businessHours.day_of_week !== '' &&
    businessHours.start_time && businessHours.end_time;

    return (
        <Modal isOpen={isOpen} toggle={toggle} autoFocus={false}>
            <ModalHeader toggle={toggle}>Create New Business Hours Set</ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => { e.preventDefault(); onSave(businessHours); }}>
                    <FormGroup>
                        <Label for="timeframe">Timeframe</Label>
                        <Input type="select" name="timeframe" id="timeframe" required
                            value={businessHours.timeframe} 
                            onChange={(e) => onInputChange('timeframe', e.target.value)}>
                                <option value="">Select Timeframe</option>
                            {timeframes.map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="day_of_week">Day of Week</Label>
                        <Input type="select"
                            id="day_of_week"
                            name="day_of_week"
                            value={businessHours.day_of_week}
                            onChange={(e) => onInputChange('day_of_week', e.target.value)}
                        >
                                <option value="">Select Day</option>
                            {Object.keys(DayOfWeek).map((key, index) => (
                                <option key={index} value={index}>{DayOfWeek[key]}</option>
                            ))}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="start_time">Start Time</Label>
                        <Input
                            type="time"
                            name="start_time"
                            id="start_time"
                            value={businessHours.start_time}
                            onChange={(e) => onInputChange('start_time', e.target.value)}
                            placeholder="Start Time"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="end_time">End Time</Label>
                        <Input
                            type="time"
                            name="end_time"
                            id="end_time"
                            value={businessHours.end_time}
                            onChange={(e) => onInputChange('end_time', e.target.value)}
                            placeholder="End Time"
                        />
                    </FormGroup>

                    <Button color="primary" type="submit" disabled={!isFormValid}>Save</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default NewBusinessHourModal;
